import { Box, IconButton } from "@mui/material";
import { Edit2 } from "iconsax-react";
interface IDeleteActionProps {
  handleEdit: () => void;
  disabled?: boolean;
}

export default function EditAction({
  handleEdit,
  disabled,
}: Readonly<IDeleteActionProps>) {
  return (
    <IconButton
      disabled={disabled}
      sx={{
        padding: "4px",
        borderRadius: "50%",
        width: "fit-content",
        cursor: "pointer",
        display: disabled ? "none" : "block",
        "&:hover": {
          color: (theme) => theme.palette.others.done,
          // backgroundColor: (theme) => theme.palette.others.doneBg,
        },
      }}
      onClick={handleEdit}
    >
      <Edit2
        size="18"
        //  color="#FF8A65"
      />
    </IconButton>
  );
}
